// Tenantra Inc. - Side panel listing the tenants and payments behind any analytics number
import { useEffect, useState } from 'react';
import { ChevronRight } from 'lucide-react';
import { DetailSheet } from '@/components/dashboard/DetailPanel';
import { money } from './kit';

export function DrillSheet({ drill, onClose, onTenant }) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    if (!drill) return;
    setRows(drill.rows || null);
    if (drill.load) drill.load().then(setRows).catch(() => setRows([]));
  }, [drill]);
  const total = (rows || []).reduce((s, r) => s + (r.amount || 0), 0);
  return (
    <DetailSheet open={!!drill} onClose={onClose} crumb={drill?.crumb || 'Analytics'} title={drill?.title} testId="drill-sheet"
      meta={rows && <span className="text-slate-500" data-testid="drill-count">{rows.length} {rows.length === 1 ? 'item' : 'items'}{drill?.showTotal !== false && total > 0 ? ` · ${money(total)}` : ''}</span>}>
      {!rows ? <div className="p-6 space-y-3">{[0, 1, 2].map(i => <div key={i} className="h-10 bg-slate-100 rounded animate-pulse" />)}</div>
        : rows.length === 0 ? <p className="px-6 py-8 text-sm text-slate-500" data-testid="drill-empty">Nothing to show.</p>
        : <ul className="divide-y divide-slate-100" data-testid="drill-rows">
          {rows.map((r, i) => (
            <li key={r.key || i}>
              <button type="button" onClick={() => r.tenant_id && onTenant(r.tenant_id)} disabled={!r.tenant_id}
                className="w-full text-left px-6 py-3 flex items-center gap-3 hover:bg-slate-50/80 transition-colors disabled:cursor-default" data-testid={`drill-row-${i}`}>
                <div className="min-w-0 flex-1">
                  <p className="text-sm text-slate-800 truncate">{r.primary}</p>
                  <p className="text-xs text-slate-500 truncate">{r.secondary}</p>
                </div>
                {r.value != null && <span className={`text-sm tabular-nums flex-shrink-0 ${r.tone || 'text-slate-700'}`}>{r.value}</span>}
                {r.tenant_id && <ChevronRight className="w-4 h-4 text-slate-300 flex-shrink-0" />}
              </button>
            </li>
          ))}
        </ul>}
    </DetailSheet>
  );
}
